/*
 * @Author: guanxiaoyan guanxiaoyan@bjca.org.cn
 * @Deion:
 * @Date: 2022-09-15 10:17:58
 * @LastEditors: guanxiaoyan guanxiaoyan@bjca.org.cn
 * @LastEditTime: 2022-10-17 18:25:27
 * @FilePath: /ywx-open/vue/src/main.js
 */
import Vue from 'vue';
import Element from 'element-ui';

import dayjs from 'dayjs';
import Egrid from 'egrid';
import API from '@/api/index';
import directives from '@/utils/directives/index'
import * as filters from '@/filters/index'; // global filters
// import errorHandler from '@/utils/errorHandle';
// import szyxErrorVue from 'szyx-error-vue';
import App from './App.vue';
import router from './router/index';
import store from './store/index';
import '@/utils/routeHooks';
/* eslint-disable */
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/iconfont.css';
import '@/styles/index.less';
import 'normalize.css';
import * as echarts from 'echarts'
import plugins from "./plugins"; // plugins
import { download } from "@/utils/followUp/request";
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import '@/styles/vxeCommon.less';
import {
  parseTime,
  resetForm,
  addDateRange,
  selectDictLabel,
  selectDictLabels,
  handleTree, } from "@/utils/followUp/ruoyi";
import constMixin from "@/constant/mixin";
// 分页组件
import Pagination from "@/components/followUp/Pagination";
// 自定义表格工具组件
import RightToolbar from "@/components/followUp/RightToolbar";
import "@/styles/tailwindcss.css";
// 引入echarts
// import echarts from 'echarts'

// Vue.prototype.$echarts = echarts
// 开发的时候关闭
// if (process.env.NODE_ENV !== 'development') szyxErrorVue(Vue);
// Vue设置
Vue.config.productionTip = false;
// Vue.config.errorHandler = errorHandler;
// window挂载
window.dayjs = dayjs;
// 属性挂载
Vue.prototype.$dayjs = dayjs;
// Vue.prototype.$throw = (error) => errorHandler(error, this);
Vue.prototype.$API = API;
Vue.prototype.$echarts = echarts
// 全局方法挂载
Vue.prototype.parseTime = parseTime;
Vue.prototype.resetForm = resetForm;
Vue.prototype.addDateRange = addDateRange;
Vue.prototype.selectDictLabel = selectDictLabel;
Vue.prototype.selectDictLabels = selectDictLabels;
Vue.prototype.download = download;
Vue.prototype.handleTree = handleTree;

// 全局随访组件挂载
Vue.component("Pagination", Pagination);
Vue.component("RightToolbar", RightToolbar);

// 引入Egrid
Vue.use(Egrid);
// 设置elementUI的默认size
Vue.use(Element, {
  size: 'medium',
});
Vue.use(VXETable)
Vue.use(plugins);
Vue.mixin(constMixin);

// 设置全局过滤器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
 // 自定义指令注册
 Object.keys(directives).forEach((key) => {
  Vue.directive(key, directives[key])
})
// 引入store
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
